export var PreferredLanguageType = /*#__PURE__*/ function(PreferredLanguageType) {
    PreferredLanguageType["EN"] = "en";
    PreferredLanguageType["FR"] = "fr";
    return PreferredLanguageType;
}({});
export var PaletteModeCode = /*#__PURE__*/ function(PaletteModeCode) {
    PaletteModeCode["light"] = "light";
    PaletteModeCode["dark"] = "dark";
    PaletteModeCode["glass"] = "glass";
    PaletteModeCode["sidebar"] = "sidebar";
    return PaletteModeCode;
}({});
